"use client";

import { auth, isFirebaseInitialized } from "@/lib/firebase";
import { User } from "firebase/auth";

export class AuthService {
  async getCurrentUser(): Promise<User | null> {
    if (!isFirebaseInitialized() || !auth) {
      return null;
    }
    return auth.currentUser;
  }

  async getCurrentUserId(): Promise<string> {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error("User not authenticated");
    }
    return user.uid;
  }

  async getCurrentUserEmail(): Promise<string> {
    const user = await this.getCurrentUser();
    if (!user || !user.email) {
      throw new Error("User not authenticated or email not available");
    }
    return user.email;
  }
}

export const authService = new AuthService();
